import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { IPaginatedResponse } from "../api";
import { IPaginationProps } from "../components/shared/Pagination";

export function usePagination() {
  const [searchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState<string | null>(null);

  const [page, setPage] = useState<number | null>(0);
  const [paginationProps, setPaginationProps] = useState<IPaginationProps>({
    pageNumberActive: 0,
    pageSize: 0,
    totalElements: 0,
    totalPages: 0,
  });

  useEffect(() => {
    const pageParam = searchParams.get("page");
    const page = pageParam != null ? parseInt(pageParam) : null;
    const searchTerm = searchParams.get("term");
    setSearchTerm(searchTerm);
    setPage(page);
  }, [searchParams]);

  function updatePagination<T>(response: IPaginatedResponse<T>) {
    if (response.result) {
      setPaginationProps({
        totalElements: response.result?.totalElements,
        totalPages: response.result?.totalPages,
        pageSize: response.result?.size,
        pageNumberActive: response.result?.number,
      });
      console.log(paginationProps);
    }
  }

  function checkPage(pageNum: number) {
    if (pageNum >= 0) {
      setPage(pageNum);
    }
  }

  return {
    searchTerm,
    page,
    paginationProps,
    updatePagination,
    setPage: checkPage,
  };
}
